import { colorPalette } from '_shared/styles/color';
import styled from 'styled-components';
import { TinyLoaderProps } from './TinyLoader.types';


export const StyledTinyLoader = styled.div<TinyLoaderProps>`
    border: 2px solid ${colorPalette.lighterSaphir};
    border-top: 2px solid ${colorPalette.saphir};
    border-radius: 50%;
    width: ${props => (props.size ? `${props.size}px` : "40px")};
    height: ${props => (props.size ? `${props.size}px` : "40px")};
    animation: spin 2s linear infinite;
    margin: 0 auto;
    ${props => props.marginLeft && `margin-left: ${props.marginLeft}px;`}
    ${props => props.marginTop && `margin-top: ${props.marginTop}px;`}
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;